import axios from "axios";
import { AddFilesRequest } from "../../../api-types/job-requests/common";
import { addProjectFileUrl } from "../../utils";

export const addProjectFile = (projectId: string, files: AddFilesRequest) => {
  return axios.post(addProjectFileUrl(projectId), files);
};
